// Sales Summary :
export const SALES_SUMMARY_REQUEST = 'SALES_SUMMARY_REQUEST';
export const SALES_SUMMARY_SUCCESS = 'SALES_SUMMARY_SUCCESS';
export const SALES_SUMMARY_FAILURE = 'SALES_SUMMARY_FAILURE';

// sales by item category :
export const SALES_BY_ITEM_CATEGORY_REQUEST = 'SALES_BY_ITEM_CATEGORY_REQUEST';
export const SALES_BY_ITEM_CATEGORY_SUCCESS = 'SALES_BY_ITEM_CATEGORY_SUCCESS';
export const SALES_BY_ITEM_CATEGORY_FAILURE = 'SALES_BY_ITEM_CATEGORY_FAILURE';

//sales by revenue class :
export const SALES_BY_REVENUE_CLASS_REQUEST = 'SALES_BY_REVENUE_CLASS_REQUEST';
export const SALES_BY_REVENUE_CLASS_SUCCESS = 'SALES_BY_REVENUE_CLASS_SUCCESS';
export const SALES_BY_REVENUE_CLASS_FAILURE = 'SALES_BY_REVENUE_CLASS_FAILURE';

//sales by channel :
export const SALES_BY_CHANNEL_REQUEST = 'SALES_BY_CHANNEL_REQUEST';
export const SALES_BY_CHANNEL_SUCCESS = 'SALES_BY_CHANNEL_SUCCESS';
export const SALES_BY_CHANNEL_FAILURE = 'SALES_BY_CHANNEL_FAILURE';

// actual sales Maghil :
export const ACTUAL_SALES_REQUEST = 'ACTUAL_SALES_REQUEST';
export const ACTUAL_SALES_SUCCESS = 'ACTUAL_SALES_SUCCESS';
export const ACTUAL_SALES_FAILURE = 'ACTUAL_SALES_FAILURE';

// actual sales third party :
export const ACTUAL_SALES_THIRD_PARTY_REQUEST = 'ACTUAL_SALES_THIRD_PARTY_REQUEST';
export const ACTUAL_SALES_THIRD_PARTY_SUCCESS = 'ACTUAL_SALES_THIRD_PARTY_SUCCESS';
export const ACTUAL_SALES_THIRD_PARTY_FAILURE = 'ACTUAL_SALES_THIRD_PARTY_FAILURE';

//Hourly sales :
export const HOURLY_SALES_REQUEST = 'HOURLY_SALES_REQUEST';
export const HOURLY_SALES_SUCCESS = 'HOURLY_SALES_SUCCESS';
export const HOURLY_SALES_FAILURE = 'HOURLY_SALES_FAILURE';

// Hourly Sales Report Chart
export const HOURLY_SALES_REPORT_CHART_REQUEST = 'HOURLY_SALES_REPORT_CHART_REQUEST';
export const HOURLY_SALES_REPORT_CHART_SUCCESS = 'HOURLY_SALES_REPORT_CHART_SUCCESS';
export const HOURLY_SALES_REPORT_CHART_FAILURE = 'HOURLY_SALES_REPORT_CHART_FAILURE';

// Live discount :
export const LIVE_DISCOUNT_REQUEST = 'LIVE_DISCOUNT_REQUEST';
export const LIVE_DISOUNT_SUCCESS = 'LIVE_DISOUNT_SUCCESS';
export const LIVE_DISCOUNT_FAILURE = 'LIVE_DISCOUNT_FAILURE';

// Open Sales :
export const LIVE_OPEN_SALES_REQUEST = 'LIVE_OPEN_SALES_REQUEST';
export const LIVE_OPEN_SALES_SUCCESS = 'LIVE_OPEN_SALES_SUCCESS';
export const LIVE_OPEN_SALES_FAILURE = 'LIVE_OPEN_SALES_FAILURE';

// live orders : Unpaid Dine-in orders
export const LIVE_ORDERS_REQUEST = 'LIVE_ORDERS_REQUEST';
export const LIVE_ORDERS_SUCCESS = 'LIVE_ORDERS_SUCCESS';
export const LIVE_ORDERS_FAILURE = 'LIVE_ORDERS_FAILURE';

// Paid Dine-in orders :
export const PAID_DINE_IN_ORDERS_REQUEST = 'PAID_DINE_IN_ORDERS_REQUEST';
export const PAID_DINE_IN_ORDERS_SUCCESS = 'PAID_DINE_IN_ORDERS_SUCCESS';
export const PAID_DINE_IN_ORDERS_FAILURE = 'PAID_DINE_IN_ORDERS_FAILURE';

// live order non dine in : Unpaid Off-Premise orders
export const LIVE_ORDER_NON_DINE_IN_REQUEST = 'LIVE_ORDER_NON_DINE_IN_REQUEST'
export const LIVE_ORDER_NON_DINE_IN_SUCCESS = 'LIVE_ORDER_NON_DINE_IN_SUCCESS'
export const LIVE_ORDER_NON_DINE_IN_FAILURE = 'LIVE_ORDER_NON_DINE_IN_FAILURE'

// Paid Off-Premise orders :
export const PAID_OFF_PREMISE_ORDERS_REQUEST = 'PAID_OFF_PREMISE_ORDERS_REQUEST'
export const PAID_OFF_PREMISE_ORDERS_SUCCESS = 'PAID_OFF_PREMISE_ORDERS_SUCCESS'
export const PAID_OFF_PREMISE_ORDERS_FAILURE = 'PAID_OFF_PREMISE_ORDERS_FAILURE'

// Paid Cancelled Orders :
export const PAID_CANCELLED_ORDERS_REQUEST = 'PAID_CANCELLED_ORDERS_REQUEST'
export const PAID_CANCELLED_ORDERS_SUCCESS = 'PAID_CANCELLED_ORDERS_SUCCESS'
export const PAID_CANCELLED_ORDERS_FAILURE = 'PAID_CANCELLED_ORDERS_FAILURE'

// live refunds :
export const LIVE_REFUNDS_REQUEST = 'LIVE_REFUNDS_REQUEST';
export const LIVE_REFUNDS_SUCCESS = 'LIVE_REFUNDS_SUCCESS';
export const LIVE_REFUNDS_FAILURE = 'LIVE_REFUNDS_FAILURE';

//  net sales :
export const LIVE_NET_SALES_REQUEST = 'LIVE_NET_SALES_REQUEST'
export const LIVE_NET_SALES_SUCCESS = 'LIVE_NET_SALES_SUCCESS'
export const LIVE_NET_SALES_FAILURE = 'LIVE_NET_SALES_FAILURE'


export const ORDER_TRACKER_REQUEST = 'ORDER_TRACKER_REQUEST'
export const ORDER_TRACKER_SUCCESS = 'ORDER_TRACKER_SUCCESS'
export const ORDER_TRACKER_FAILURE = 'ORDER_TRACKER_FAILURE'

export const OVERALL_ORDER_NON_DINE_IN_REQUEST = 'OVERALL_ORDER_NON_DINE_IN_REQUEST'
export const OVERALL_ORDER_NON_DINE_IN_SUCCESS = 'OVERALL_ORDER_NON_DINE_IN_SUCCESS'
export const OVERALL_ORDER_NON_DINE_IN_FAILURE = 'OVERALL_ORDER_NON_DINE_IN_FAILURE'

// discuount summary :
export const DISCOUNT_SUMMARY_REQUEST = 'DISCOUNT_SUMMARY_REQUEST';
export const DISCOUNT_SUMMARY_SUCCESS = 'DISCOUNT_SUMMARY_SUCCESS';
export const DISCOUNT_SUMMARY_FAILURE = 'DISCOUNT_SUMMARY_FAILURE';

// cancellation summary :
export const CANCELLATION_SUMMARY_REQUEST = 'CANCELLATION_SUMMARY_REQUEST'
export const CANCELLATION_SUMMARY_SUCCESS = 'CANCELLATION_SUMMARY_SUCCESS'
export const CANCELLATION_SUMMARY_FAILURE = 'CANCELLATION_SUMMARY_FAILURE'

// employee staff tip gratuity :
export const EMPLOYEE_STAFF_TIP_GRATUITY_REQUEST = 'EMPLOYEE_STAFF_TIP_GRATUITY_REQUEST'
export const EMPLOYEE_STAFF_TIP_GRATUITY_SUCCESS = 'EMPLOYEE_STAFF_TIP_GRATUITY_SUCCESS'
export const EMPLOYEE_STAFF_TIP_GRATUITY_FAILURE = 'EMPLOYEE_STAFF_TIP_GRATUITY_FAILURE'

// employee staff discount :
export const EMPLOYEE_STAFF_DISCOUNT_REQUEST = 'EMPLOYEE_STAFF_DISCOUNT_REQUEST'
export const EMPLOYEE_STAFF_DISCOUNT_SUCCESS = 'EMPLOYEE_STAFF_DISCOUNT_SUCCESS'
export const EMPLOYEE_STAFF_DISCOUNT_FAILURE = 'EMPLOYEE_STAFF_DISCOUNT_FAILURE'

// employee staff performance :
export const EMPLOYEE_STAFF_PERFORMANCE_REQUEST = 'EMPLOYEE_STAFF_PERFORMANCE_REQUEST'
export const EMPLOYEE_STAFF_PERFORMANCE_SUCCESS = 'EMPLOYEE_STAFF_PERFORMANCE_SUCCESS'
export const EMPLOYEE_STAFF_PERFORMANCE_FAILURE = 'EMPLOYEE_STAFF_PERFORMANCE_FAILURE'

// employee staff activity :
export const EMPLOYEE_STAFF_ACTIVITY_REQUEST = 'EMPLOYEE_STAFF_ACTIVITY_REQUEST'
export const EMPLOYEE_STAFF_ACTIVITY_SUCCESS = 'EMPLOYEE_STAFF_ACTIVITY_SUCCESS'
export const EMPLOYEE_STAFF_ACTIVITY_FAILURE = 'EMPLOYEE_STAFF_ACTIVITY_FAILURE'

// day checkIn :
export const DAY_CHECKIN_REQUEST = 'DAY_CHECKIN_REQUEST'
export const DAY_CHECKIN_SUCCESS = 'DAY_CHECKIN_SUCCESS'
export const DAY_CHECKIN_FAILURE = 'DAY_CHECKIN_FAILURE'

// daily checkIn :
export const DAILY_CHECKIN_REQUEST = 'DAILY_CHECKIN_REQUEST'
export const DAILY_CHECKIN_SUCCESS = 'DAILY_CHECKIN_SUCCESS'
export const DAILY_CHECKIN_FAILURE = 'DAILY_CHECKIN_FAILURE'

// daily guests :
export const DAILY_GUEST_REQUEST = 'DAILY_GUEST_REQUEST'
export const DAILY_GUEST_SUCCESS = 'DAILY_GUEST_SUCCESS'
export const DAILY_GUEST_FAILURE = 'DAILY_GUEST_FAILURE'

// daily cancellation :
export const DAILY_CANCELLATION_REQUEST = 'DAILY_CANCELLATION_REQUEST'
export const DAILY_CANCELLATION_SUCCESS = 'DAILY_CANCELLATION_SUCCESS'
export const DAILY_CANCELLATION_FAILURE = 'DAILY_CANCELLATION_FAILURE'

// hourly guests :
export const HOURLY_GUESTS_REQUEST = 'HOURLY_GUESTS_REQUEST';
export const HOURLY_GUESTS_SUCCESS = 'HOURLY_GUESTS_SUCCESS';
export const HOURLY_GUESTS_FAILURE = 'HOURLY_GUESTS_FAILURE';

// daily hourly checkIn :
export const DAILY_HOURLY_CHECKIN_REQUEST = 'DAILY_HOURLY_CHECKIN_REQUEST';
export const DAILY_HOURLY_CHECKIN_SUCCESS = 'DAILY_HOURLY_CHECKIN_SUCCESS';
export const DAILY_HOURLY_CHECKIN_FAILURE = 'DAILY_HOURLY_CHECKIN_FAILURE';

// day over day guest :
export const DAY_OVER_DAY_GUEST_REQUEST = 'DAY_OVER_DAY_GUEST_REQUEST';
export const DAY_OVER_DAY_GUEST_SUCCESS = 'DAY_OVER_DAY_GUEST_SUCCESS';
export const DAY_OVER_DAY_GUEST_FAILURE = 'DAY_OVER_DAY_GUEST_FAILURE';

// peak summary
export const PEAK_SUMMARY_REQUEST = 'PEAK_SUMMARY_REQUEST';
export const PEAK_SUMMARY_SUCCESS = 'PEAK_SUMMARY_SUCCESS';
export const PEAK_SUMMARY_FAILURE = 'PEAK_SUMMARY_FAILURE';

// party size
export const PARTY_SIZE_REQUEST = 'PARTY_SIZE_REQUEST';
export const PARTY_SIZE_SUCCESS = 'PARTY_SIZE_SUCCESS';
export const PARTY_SIZE_FAILURE = 'PARTY_SIZE_FAILURE';

// customer size
export const CUSTOMER_SIZE_REQUEST = 'CUSTOMER_SIZE_REQUEST';
export const CUSTOMER_SIZE_SUCCESS = 'CUSTOMER_SIZE_SUCCESS';
export const CUSTOMER_SIZE_FAILURE = 'CUSTOMER_SIZE_FAILURE';

// new customer size
export const NEW_CUSTOMER_SIZE_REQUEST = 'NEW_CUSTOMER_SIZE_REQUEST'
export const NEW_CUSTOMER_SIZE_SUCCESS = 'NEW_CUSTOMER_SIZE_SUCCESS'
export const NEW_CUSTOMER_SIZE_FAILURE = 'NEW_CUSTOMER_SIZE_FAILURE'

// customer details
export const CUSTOMER_DETAILS_REQUEST = 'CUSTOMER_DETAILS_REQUEST';
export const CUSTOMER_DETAILS_SUCCESS = 'CUSTOMER_DETAILS_SUCCESS';
export const CUSTOMER_DETAILS_FAILURE = 'CUSTOMER_DETAILS_FAILURE';

// live check-in status
export const LIVE_CHECKIN_STATUS_REQUEST = 'LIVE_CHECKIN_STATUS_REQUEST';
export const LIVE_CHECKIN_STATUS_SUCCESS = 'LIVE_CHECKIN_STATUS_SUCCESS';
export const LIVE_CHECKIN_STATUS_FAILURE = 'LIVE_CHECKIN_STATUS_FAILURE';

// daily CheckIn Status
export const DAILY_CHECKIN_STATUS_REQUEST = 'DAILY_CHECKIN_STATUS_REQUEST';
export const DAILY_CHECKIN_STATUS_SUCCESS = 'DAILY_CHECKIN_STATUS_SUCCESS';
export const DAILY_CHECKIN_STATUS_FAILURE = 'DAILY_CHECKIN_STATUS_FAILURE';

//billed
export const BILLED_REQUEST = "BILLED_REQUEST"
export const BILLED_SUCCESS = "BILLED_SUCCESS"
export const BILLED_FAILURE = "BILLED_FAILURE"

//unbilled
export const UNBILLED_REQUEST = "UNBILLED_REQUEST"
export const UNBILLED_SUCCESS = "UNBILLED_SUCCESS"
export const UNBILLED_FAILURE = "UNBILLED_FAILURE"


// employee sales overview
export const EMPLOYEE_SALES_OVERVIEW_REQUEST = 'EMPLOYEE_SALES_OVERVIEW_REQUEST';
export const EMPLOYEE_SALES_OVERVIEW_SUCCESS = 'EMPLOYEE_SALES_OVERVIEW_SUCCESS';
export const EMPLOYEE_SALES_OVERVIEW_FAILURE = 'EMPLOYEE_SALES_OVERVIEW_FAILURE';

export const SELCTED_DATE_FILTER_TYPE = 'SELCTED_DATE_FILTER_TYPE';
export const SELCTED_START_DATE = 'SELCTED_START_DATE';
export const SELCTED_END_DATE = 'SELCTED_END_DATE';
export const SELCTED_LOCATION = 'SELCTED_LOCATION';
export const STORE_LOCATIONS_LIST = 'STORE_LOCATIONS_LIST';
export const SELCTED_CATEGORIES = 'SELCTED_CATEGORIES';
export const SELCTED_ITEMS = 'SELCTED_ITEMS';

export const SELCTED_DATE_FILTER_TYPE_EOD = "SELCTED_DATE_FILTER_TYPE_EOD";
export const SELCTED_START_DATE_EOD = "SELCTED_START_DATE_EOD";
export const SELCTED_END_DATE_EOD = "SELCTED_END_DATE_EOD";


// Voided Summary
export const VOIDED_SUMMARY_REQUEST = 'VOIDED_SUMMARY_REQUEST';
export const VOIDED_SUMMARY_SUCCESS = 'VOIDED_SUMMARY_SUCCESS';
export const VOIDED_SUMMARY_FAILURE = 'VOIDED_SUMMARY_FAILURE';

// Dropdown Details
export const DROPDOWN_DETAILS_REQUEST = 'DROPDOWN_DETAILS_REQUEST';
export const DROPDOWN_DETAILS_SUCCESS = 'DROPDOWN_DETAILS_SUCCESS';
export const DROPDOWN_DETAILS_FAILURE = 'DROPDOWN_DETAILS_FAILURE';

// Category Channel Summary
export const CATEGORY_CHANNEL_SUMMARY_REQUEST = 'CATEGORY_CHANNEL_SUMMARY_REQUEST';
export const CATEGORY_CHANNEL_SUMMARY_SUCCESS = 'CATEGORY_CHANNEL_SUMMARY_SUCCESS';
export const CATEGORY_CHANNEL_SUMMARY_FAILURE = 'CATEGORY_CHANNEL_SUMMARY_FAILURE';

// Category Sales
export const CATEGORY_SALES_REQUEST = 'CATEGORY_SALES_REQUEST';
export const CATEGORY_SALES_SUCCESS = 'CATEGORY_SALES_SUCCESS';
export const CATEGORY_SALES_FAILURE = 'CATEGORY_SALES_FAILURE';

// Category Sales Summary
export const CATEGORY_SALES_SUMMARY_REQUEST = 'CATEGORY_SALES_SUMMARY_REQUEST';
export const CATEGORY_SALES_SUMMARY_SUCCESS = 'CATEGORY_SALES_SUMMARY_SUCCESS';
export const CATEGORY_SALES_SUMMARY_FAILURE = 'CATEGORY_SALES_SUMMARY_FAILURE';

// Sales Summary Report
export const SALES_SUMMARY_REPORT_REQUEST = 'SALES_SUMMARY_REPORT_REQUEST';
export const SALES_SUMMARY_REPORT_SUCCESS = 'SALES_SUMMARY_REPORT_SUCCESS';
export const SALES_SUMMARY_REPORT_FAILURE = 'SALES_SUMMARY_REPORT_FAILURE';

// Staff Sales
export const STAFF_SALES_REQUEST = 'STAFF_SALES_REQUEST';
export const STAFF_SALES_SUCCESS = 'STAFF_SALES_SUCCESS';
export const STAFF_SALES_FAILURE = 'STAFF_SALES_FAILURE';

// Sales Tags
export const SALES_TAGS_REQUEST = 'SALES_TAGS_REQUEST';
export const SALES_TAGS_SUCCESS = 'SALES_TAGS_SUCCESS';
export const SALES_TAGS_FAILURE = 'SALES_TAGS_FAILURE';

// Payment Details
export const PAYMENT_DETAILS_REQUEST = 'PAYMENT_DETAILS_REQUEST';
export const PAYMENT_DETAILS_SUCCESS = 'PAYMENT_DETAILS_SUCCESS';
export const PAYMENT_DETAILS_FAILURE = 'PAYMENT_DETAILS_FAILURE';

// // Hourly Sales
// export const HOURLY_SALES_REQUEST = 'HOURLY_SALES_REQUEST';
// export const HOURLY_SALES_SUCCESS = 'HOURLY_SALES_SUCCESS';
// export const HOURLY_SALES_FAILURE = 'HOURLY_SALES_FAILURE';

// Sales Category
export const SALES_CATEGORY_REQUEST = 'SALES_CATEGORY_REQUEST';
export const SALES_CATEGORY_SUCCESS = 'SALES_CATEGORY_SUCCESS';
export const SALES_CATEGORY_FAILURE = 'SALES_CATEGORY_FAILURE';

// Sales Card Type
export const SALES_CARD_TYPE_REQUEST = 'SALES_CARD_TYPE_REQUEST';
export const SALES_CARD_TYPE_SUCCESS = 'SALES_CARD_TYPE_SUCCESS';
export const SALES_CARD_TYPE_FAILURE = 'SALES_CARD_TYPE_FAILURE';

// getSalesCardType
export const GET_SALES_CARD_TYPE_REQUEST = 'GET_SALES_CARD_TYPE_REQUEST';
export const GET_SALES_CARD_TYPE_SUCCESS = 'GET_SALES_CARD_TYPE_SUCCESS';
export const GET_SALES_CARD_TYPE_FAILURE = 'GET_SALES_CARD_TYPE_FAILURE';

// Location Details
export const LOCATION_DETAILS_REQUEST = 'LOCATION_DETAILS_REQUEST';
export const LOCATION_DETAILS_SUCCESS = 'LOCATION_DETAILS_SUCCESS';
export const LOCATION_DETAILS_FAILURE = 'LOCATION_DETAILS_FAILURE';

// getSalesCategory
export const GET_SALES_CATEGORY_REQUEST = 'GET_SALES_CATEGORY_REQUEST';
export const GET_SALES_CATEGORY_SUCCESS = 'GET_SALES_CATEGORY_SUCCESS';
export const GET_SALES_CATEGORY_FAILURE = 'GET_SALES_CATEGORY_FAILURE';

//getOfferSummary
export const GET_OFFER_SUMMARY_REQUEST = 'GET_OFFER_SUMMARY_REQUEST';
export const GET_OFFER_SUMMARY_SUCCESS = 'GET_OFFER_SUMMARY_SUCCESS';
export const GET_OFFER_SUMMARY_FAILURE = 'GET_OFFER_SUMMARY_FAILURE';

//getVoidedOrderSummary
export const GET_VOIDED_ORDER_SUMMARY_REQUEST = 'GET_VOIDED_ORDER_SUMMARY_REQUEST';
export const GET_VOIDED_ORDER_SUMMARY_SUCCESS = 'GET_VOIDED_ORDER_SUMMARY_SUCCESS';
export const GET_VOIDED_ORDER_SUMMARY_FAILURE = 'GET_VOIDED_ORDER_SUMMARY_FAILURE';

//get employee activity
export const GET_EMPLOYEE_ACTIVITY_REQUEST = 'GET_EMPLOYEE_ACTIVITY_REQUEST';
export const GET_EMPLOYEE_ACTIVITY_SUCCESS = 'GET_EMPLOYEE_ACTIVITY_SUCCESS';
export const GET_EMPLOYEE_ACTIVITY_FAILURE = 'GET_EMPLOYEE_ACTIVITY_FAILURE';

// Category List
export const ADD_CATEGORY_LIST = 'ADD_CATEGORY_LIST';
export const ADD_ITEMS_LIST = 'ADD_ITEMS_LIST';

// getPremisesSummary
export const GET_PREMISES_SUMMARARY_REQUEST = 'GET_PREMISES_SUMMARARY_REQUEST';
export const GET_PREMISES_SUMMARARY_SUCCESS = 'GET_PREMISES_SUMMARARY_SUCCESS';
export const GET_PREMISES_SUMMARARY_FAILURE = 'GET_PREMISES_SUMMARARY_FAILURE';

// get employee chart slice table
export const GET_EMPLOYEE_CHART_SLICE_TABLE_REQUEST = "GET_EMPLOYEE_CHART_SLICE_TABLE_REQUEST"
export const GET_EMPLOYEE_CHART_SLICE_TABLE_SUCCESS = "GET_EMPLOYEE_CHART_SLICE_TABLE_SUCCESS" 
export const GET_EMPLOYEE_CHART_SLICE_TABLE_FAILURE = "GET_EMPLOYEE_CHART_SLICE_TABLE_FAILURE" 


export const GET_DETAILS_RESTAURANT_REQUEST = "GET_DETAILS_RESTAURANT_REQUEST"
export const GET_DETAILS_RESTAURANT_SUCCESS = "GET_DETAILS_RESTAURANT_SUCCESS"
export const GET_DETAILS_RESTAURANT_FAILURE = "GET_DETAILS_RESTAURANT_FAILURE"

// getDownloadableReport
export const GET_DOWNLOADABLE_REPORT_REQUEST = "GET_DOWNLOADABLE_REPORT_REQUEST"
export const GET_DOWNLOADABLE_REPORT_SUCCESS = "GET_DOWNLOADABLE_REPORT_SUCCESS"
export const GET_DOWNLOADABLE_REPORT_FAILURE = "GET_DOWNLOADABLE_REPORT_FAILURE"

//
export const GET_TENDER_TYPE_REQUEST = "GET_TENDER_TYPE_REQUEST"
export const GET_TENDER_TYPE_SUCCESS = "GET_TENDER_TYPE_SUCCESS"
export const GET_TENDER_TYPE_FAILURE = "GET_TENDER_TYPE_FAILURE"

// Order Info :
export const ORDER_INFO_REQUEST = "ORDER_INFO_REQUEST"
export const ORDER_INFO_SUCCESS = "ORDER_INFO_SUCCESS"
export const ORDER_INFO_FAILURE = "ORDER_INFO_FAILURE"

//voided orders sales overview
export const VOIDED_ORDERS_SALES_REQUEST = "VOIDED_ORDERS_SALES_REQUEST"
export const VOIDED_ORDERS_SALES_SUCCESS = "VOIDED_ORDERS_SALES_SUCCESS"
export const VOIDED_ORDERS_SALES_FAILURE = "VOIDED_ORDERS_SALES_FAILURE"

//Complementary doughnut chart
export const COMPLEMENTARY_DATA_REQUEST = 'COMPLEMENTARY_DATA_REQUEST'
export const COMPLEMENTARY_DATA_SUCCESS = 'COMPLEMENTARY_DATA_SUCCESS'
export const COMPLEMENTARY_DATA_FAILURE = 'COMPLEMENTARY_DATA_FAILURE'

//voided orders sales overview Table
export const VOIDED_ORDERS_TABLE_REQUEST = 'VOIDED_ORDERS_TABLE_REQUEST'
export const VOIDED_ORDERS_TABLE_SUCCESS = 'VOIDED_ORDERS_TABLE_SUCCESS'
export const VOIDED_ORDERS_TABLE_FAILURE = 'VOIDED_ORDERS_TABLE_FAILURE'

//complementary table
export const COMPLEMENTARY_TABLE_REQUEST = 'COMPLEMENTARY_TABLE_REQUEST'
export const COMPLEMENTARY_TABLE_SUCCESS = 'COMPLEMENTARY_TABLE_SUCCESS'
export const COMPLEMENTARY_TABLE_FAILURE = 'COMPLEMENTARY_TABLE_FAILURE'

// Unpaid Voided Orders
export const UNPAID_VOIDED_ORDERS_REQUEST = 'UNPAID_VOIDED_ORDERS_REQUEST';
export const UNPAID_VOIDED_ORDERS_SUCCESS = 'UNPAID_VOIDED_ORDERS_SUCCESS';
export const UNPAID_VOIDED_ORDERS_FAILURE = 'UNPAID_VOIDED_ORDERS_FAILURE';

// Paid Voided Orders
export const PAID_VOIDED_ORDERS_REQUEST = 'PAID_VOIDED_ORDERS_REQUEST';
export const PAID_VOIDED_ORDERS_SUCCESS = 'PAID_VOIDED_ORDERS_SUCCESS';
export const PAID_VOIDED_ORDERS_FAILURE = 'PAID_VOIDED_ORDERS_FAILURE';

// Unpaid Complementary Orders
export const UNPAID_COMPLEMENTARY_ORDERS_REQUEST = 'UNPAID_COMPLEMENTARY_ORDERS_REQUEST';
export const UNPAID_COMPLEMENTARY_ORDERS_SUCCESS = 'UNPAID_COMPLEMENTARY_ORDERS_SUCCESS';
export const UNPAID_COMPLEMENTARY_ORDERS_FAILURE = 'UNPAID_COMPLEMENTARY_ORDERS_FAILURE';

// TODO: remove logout logic to separate file
export const LOGOUT = 'LOGOUT';
